import {
  AlignCenterVertically,
  AlignLeft,
  AlignRight,
  BorderDashed,
  BorderDashedSmall,
  DividerSize,
  DividerSizeLarge,
  DividerSizeLargeSmall,
  DividerSizeMedium,
  DividerSizeMediumSmall,
  DividerSizeSmall,
  Equal,
  EqualSmall,
  LineDotted,
  LineDottedSmall,
  Minus,
  MinusSmall
} from "@wix/wix-ui-icons-common";
import {
  SIZE_DROPDDOWN_OPTION_LARGE,
  SIZE_DROPDDOWN_OPTION_MEDIUM,
  SIZE_DROPDDOWN_OPTION_SMALL,
  STYLE_DROPDOWN_OPTION_DASHED,
  STYLE_DROPDOWN_OPTION_DOTTED,
  STYLE_DROPDOWN_OPTION_DOUBLE,
  STYLE_DROPDOWN_OPTION_SINGLE
} from "../../data-hooks.js";
const dividerSizeData = [
  {
    text: "SizeSmallButton_Tooltip",
    tooltip: "SizeSmallButton_Tooltip",
    commandKey: "SMALL",
    icon: DividerSize,
    iconSmall: DividerSizeSmall,
    dataHook: SIZE_DROPDDOWN_OPTION_SMALL
  },
  {
    text: "SizeContentButton_Tooltip",
    tooltip: "SizeContentButton_Tooltip",
    commandKey: "MEDIUM",
    icon: DividerSizeMedium,
    iconSmall: DividerSizeMediumSmall,
    dataHook: SIZE_DROPDDOWN_OPTION_MEDIUM
  },
  {
    text: "SizeFullWidthButton_Tooltip",
    tooltip: "SizeFullWidthButton_Tooltip",
    commandKey: "LARGE",
    icon: DividerSizeLarge,
    iconSmall: DividerSizeLargeSmall,
    dataHook: SIZE_DROPDDOWN_OPTION_LARGE
  }
];
const dividerStyleData = [
  {
    commandKey: "SINGLE",
    icon: Minus,
    iconSmall: MinusSmall,
    dataHook: STYLE_DROPDOWN_OPTION_SINGLE,
    text: "DividerPlugin_SingleLineStyleOption"
  },
  {
    commandKey: "DOUBLE",
    icon: Equal,
    iconSmall: EqualSmall,
    dataHook: STYLE_DROPDOWN_OPTION_DOUBLE,
    text: "DividerPlugin_DoubleLineStyleOption"
  },
  {
    commandKey: "DASHED",
    icon: BorderDashed,
    iconSmall: BorderDashedSmall,
    dataHook: STYLE_DROPDOWN_OPTION_DASHED,
    text: "DividerPlugin_DashedLineStyleOption"
  },
  {
    commandKey: "DOTTED",
    icon: LineDotted,
    iconSmall: LineDottedSmall,
    dataHook: STYLE_DROPDOWN_OPTION_DOTTED,
    text: "DividerPlugin_DottedLineStyleOption"
  }
];
const alignmentMap = {
  LEFT: AlignLeft,
  CENTER: AlignCenterVertically,
  RIGHT: AlignRight
};
export {
  alignmentMap,
  dividerSizeData,
  dividerStyleData
};
//# sourceMappingURL=dividerButtonsData.js.map
